<template>
  <div>
    <!-- Main Topic -->
    <div>
      <label>Main topic</label>
      <BaseTextarea
        type="text"
        placeholder="es. scoperta delle tradizioni artigianali alpine attraverso borghi e mercatini locali"
        v-model="form.main_topic"
      />
    </div>

    <!-- Keywords -->
    <div class="mt-2">
      <label>Contenuti in evidenza
        <el-tooltip placement="top">
          <div slot="content">Contenuti in evidenza (eventi, punti di interesse, località per guidare la ricerca)</div>
          <i class="fa-solid fa-circle-info ml-1" style="cursor: pointer;"></i>
        </el-tooltip>
      </label>
      <div class="input_with_btn">
        <BaseInput
          class="flex-grow-1"
          type="text"
          placeholder="es. Dolomiti Ski Jazz, Madonna di Campiglio, Rifugio Pedrotti"
          v-model="newKeyword"
          @keyup.enter="addKeyword"
        />
        <button
          class="btn__search"
          type="button"
          @click="addKeyword"
          :disabled="!newKeyword.trim()"
        >
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
      <div class="pb-3 mt-2">
        <div class="bulk-file-list d-flex flex-wrap">
          <div
            class="seo_article__keyword mr-2 mb-2"
            v-for="(keyword, index) in form.keywords"
            :key="index"
          >
            <p class="mb-0 seo_article__p">
              {{ keyword }}
              <i
                @click.prevent="removeKeyword(keyword)"
                class="fa-regular fa-xmark seo_article__asterisk"
              ></i>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Article Kind -->
    <div class="row">
      <div class="col">
        <label>Tipologia di comunicato</label>
        <el-select
          :popper-append-to-body="false"
          class="select-primary"
          size="medium"
          v-model="form.article_kind"
        >
          <el-option value="comunicato stampa" label="Comunicato Stampa" />
          <el-option value="lancio" label="Lancio" />
        </el-select>
      </div>
    </div>

    <!-- Article Length (only for comunicato stampa) -->
    <div class="row mt-2" v-if="form.article_kind === 'comunicato stampa'">
      <div class="col">
        <label>Lunghezza</label>
        <el-select
          :popper-append-to-body="false"
          class="select-primary"
          size="medium"
          v-model="form.article_length"
        >
          <el-option :value="2000" label="Corto (circa 2000 caratteri)" />
          <el-option :value="5000" label="Medio (circa 5000 caratteri)" />
          <el-option :value="8000" label="Lungo (circa 8000 caratteri)" />
        </el-select>
      </div>
    </div>

    <!-- Brand Voice -->
    <div class="row mt-2">
      <div class="col">
        <BrandVoicesSelect
          :brand-voice-selected="form.brand_voice_id || null"
          @change="form.brand_voice_id = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BaseInput, BaseTextarea } from 'src/components/index';
import { Select, Option } from 'element-ui';
import BrandVoicesSelect from 'src/pages/Tools/ToolsComponent/BrandVoicesSelect.vue';

export default {
  name: 'PressReleaseInputsForm',
  components: {
    BaseInput,
    BaseTextarea,
    [Option.name]: Option,
    [Select.name]: Select,
    BrandVoicesSelect,
  },
  props: {
    jsonData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        main_topic: this.jsonData?.main_topic ?? '',
        keywords: Array.isArray(this.jsonData?.keywords)
          ? [...this.jsonData.keywords]
          : [],
        article_kind: this.jsonData?.article_kind ?? '',
        article_length: this.jsonData?.article_length
          ? Number(this.jsonData.article_length)
          : null,
        translate_from: this.jsonData?.translate_from ?? 'it',
        brand_voice_id: this.jsonData?.brand_voice_id ?? '',
      },
      newKeyword: '',
    };
  },
  watch: {
    jsonData: {
      handler(newVal) {
        if (!newVal) return;
        this.form.main_topic = newVal.main_topic ?? '';
        this.form.keywords = Array.isArray(newVal.keywords)
          ? [...newVal.keywords]
          : [];
        this.form.article_kind = newVal.article_kind ?? '';
        this.form.article_length = newVal.article_length
          ? Number(newVal.article_length)
          : null;
        this.form.translate_from = newVal.translate_from ?? 'it';
        this.form.brand_voice_id = newVal.brand_voice_id ?? '';
      },
      deep: true,
    },
    'form.article_kind'(newVal) {
      if (newVal === 'lancio') {
        this.form.article_length = 750;
      } else if (this.form.article_length === 750) {
        this.form.article_length = null;
      }
    },
    form: {
      handler() {
        this.$emit('update:formData', { ...this.form });
      },
      deep: true,
    },
  },
  methods: {
    addKeyword() {
      const trimmed = this.newKeyword.trim();
      if (trimmed && !this.form.keywords.includes(trimmed)) {
        this.form.keywords.push(trimmed);
        this.newKeyword = '';
      }
    },
    removeKeyword(keywordToRemove) {
      this.form.keywords = this.form.keywords.filter(
        (kw) => kw !== keywordToRemove
      );
    },
  },
  mounted() {
    this.$emit('update:formData', { ...this.form });
  },
};
</script>
